import {
  CalendarClock,
  Linkedin,
  Mail,
  Phone,
  StickyNote,
} from "lucide-react";

/**
 * Activity types for logged occurrences on the timeline. Every logged entry
 * is one of these; "note" is the default. Production maps each to its spine
 * event type - the demo stores it on the note record.
 */

export interface ActivityTypeDef {
  id: string;
  label: string;
  /** Verb phrase for the timeline header: "You logged a call". */
  logged: string;
  icon: typeof StickyNote;
}

export const ACTIVITY_TYPES: ActivityTypeDef[] = [
  { id: "note", label: "Note", logged: "added a note", icon: StickyNote },
  { id: "call", label: "Call", logged: "logged a call", icon: Phone },
  { id: "email", label: "Email", logged: "logged an email", icon: Mail },
  { id: "meeting", label: "Meeting", logged: "logged a meeting", icon: CalendarClock },
  { id: "linkedin", label: "LinkedIn", logged: "logged a LinkedIn message", icon: Linkedin },
];

export const activityTypeOf = (id?: string): ActivityTypeDef =>
  ACTIVITY_TYPES.find((t) => t.id === id) ?? ACTIVITY_TYPES[0]!;
